﻿import React from 'react';
import RawHtml from '../../../../UI/RawHtml';

const EnvLogoText = (props) => {

    return (
        <RawHtml>{props.text}</RawHtml>
     )
 }                

export default EnvLogoText;